export default "__VITE_ASSET__BWKqqIOH__"